<template>
  <div class="content">
    <div class="content-main">
      <p class="content-title">身份证审核</p>
      <div class="content-input">
        <div class="content-input-item">
          <label>性别：</label>
          <el-select v-model="sex" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in sexArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>公开性：</label>
          <el-select v-model="openState" placeholder="Select" style="width: 8em">
            <el-option v-for="item in openStateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>认证类型：</label>
          <el-select v-model="authType" placeholder="Select" style="width: 8em" @change="idenStartChange">
            <el-option v-for="item in authTypeArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>进入情况：</label>
          <el-select v-model="enterType" placeholder="Select" style="width: 8em">
            <el-option v-for="item in enterTypeArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>身份认证状态：</label>
          <el-select v-model="idenState" placeholder="Select" style="width: 8em">
            <el-option v-for="item in idenStateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>封号状态：</label>
          <el-select v-model="forbiddenState" placeholder="Select" style="width: 8em">
            <el-option v-for="item in forbiddenStateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>注销状态：</label>
          <el-select v-model="resumeDel" placeholder="Select" style="width: 8em">
            <el-option v-for="item in resumeDelArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>总状态：</label>
          <el-select v-model="overallAuthState" placeholder="Select" style="width: 8em">
            <el-option v-for="item in overallAuthStateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>身份认证类型：</label>
          <el-select v-model="type" placeholder="Select" style="width: 8em">
            <el-option v-for="item in typeArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>关注类型：</label>
          <el-select v-model="focusState" placeholder="Select" style="width: 7.4em">
            <el-option v-for="item in focusStateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <DatePickerRange title="提交时间：" @date="getTime($event)" @check="getCheck($event)" :isChecked="isChecked"/>
        </div>
        <div class="content-input-item">
          <DatePickerRange30 title="登陆时间：" @date="getLoginTime($event)" @check="getLoginCheck($event)" :isChecked="isLoginChecked"/>
        </div>
        <div class="content-input-item">
          <SearchComponents :searchTypeList="searchTypeList" :searchType="searchType"  :searchValue="searchValue" @searchType="getSearchType($event)" @searchValue="getSearchValue($event)" />
        </div>
        <div class="content-input-item">
          <ElButtons type="primary" icon="search" @click="getPage(true)" v-loading="searchLoading"> 查询 </ElButtons>
          <ElButtons icon="RefreshLeft" @click="refreshParam"> 重置 </ElButtons>
        </div>
      </div>
    </div>
    <div class="content-main">
      <div class="content-button">
        <div style="display: flex; align-items: center;">
          <ElButtons icon="Comment" @click="sendSysMsg">发送通知</ElButtons>
          <el-button type="danger" @click="batchReject">批量不通过</el-button>
          <el-button type="warning" @click="updateFocusState(5)" v-loading="focusLoading">设为关注</el-button>
          <el-button type="success" @click="updateFocusState(3)" v-loading="focusLoading">取消关注</el-button>
        </div>
        <div style="display: flex; justify-content: flex-end; align-items: center">
          <div style="display: flex; justify-content: flex-end; align-items: center">
            <SearchUidOrPhone v-if="showSearch" style="margin-right: 16px;" @confirm="openDialog($event)"/>
            <el-button v-if="!showSearch" @click="showSearch = true" type="warning">实名操作</el-button>
            <el-button v-if="showSearch" @click="showSearch = false">取消</el-button>
          </div>
          <BtnGroup :tableRef="$refs.multipleTableRef" :colList="colList" @colListChange="colListChange($event)" @refresh="getPage"></BtnGroup>
        </div>

      </div>
      <div class="content-table">
        <el-table
            ref="multipleTableRef"
            :data="pageDataList"
            style="width: 100%"
            border
            @cell-click="toggleSelection"
            v-loading="listLoading"
            @selection-change="selsChange"
            @header-click="selsAll"
        >
          <el-table-column type="selection" width="55" align="center" class-name="cursor"/>
          <el-table-column property="identityUpdateTime" label="认证时间" v-if="checkColList.indexOf('认证时间') > -1" width="90"/>
          <el-table-column property="submitTime" label="提交时间" v-if="checkColList.indexOf('提交时间') > -1" width="90"/>
          <el-table-column label="头像" v-if="checkColList.indexOf('头像') > -1" width="105">
            <template #default="scope">
              <HeadImg :images="scope.row.headImg" />
            </template>
          </el-table-column>
          <el-table-column label="用户信息" v-if="checkColList.indexOf('用户信息') > -1" width="200">
            <template #default="scope">
              <UserInfoList :row="scope.row" showList="name,phone,uid,city"/>
              <p>邀请码：{{ scope.row.inviteCode }}</p>
              <p>进入码：{{ scope.row.enterCode == 0?'':scope.row.enterCode }}</p>
              <el-button type="danger" size="small" v-show="scope.row.isRepeat == 1" @click="repeat(scope.row)">身份证号码重复</el-button>
              <el-button type="primary" size="small" v-show="scope.row.isRepeat == 2" @click="repeat(scope.row)">因注销导致身份证重复</el-button>
            </template>
          </el-table-column>
          <el-table-column prop="" label="期望结婚时间" v-if="checkColList.indexOf('期望结婚时间') > -1" width="110">
            <template #default="scope">
              <span>{{scope.row.marryTime==0?'未填写':scope.row.marryTime==1?'半年内':scope.row.marryTime==2?'1年内':scope.row.marryTime==3?'2年内':scope.row.marryTime==4?'3年内':'找恋爱对象'}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="" label="进入情况" v-if="checkColList.indexOf('进入情况') > -1" min-width="90">
            <template #default="scope">
              <span>{{scope.row.enterType==0?'免费进入':scope.row.enterType==1?'邀请码进入':scope.row.enterType==2?'认证费用':scope.row.enterType==3?'保证金进入+认证费用':scope.row.enterType==4?'保证金+邀请码':scope.row.enterType==5?'直接进入':scope.row.enterType==6?'芝麻认证进入':scope.row.enterType==7?'身份证直接进入':scope.row.enterType==null?'未进入':''}}</span>
            </template>
          </el-table-column>
          <el-table-column label="身份证照片" v-if="checkColList.indexOf('身份证照片') > -1" min-width="192">
            <template #default="scope">
              <el-space>
                <el-image fit="fill" style="width: 80px; height: 80px;" :src="scope.row.imgZ" class="cursor"><template #error><div class="el-img-error">暂无图片</div></template></el-image>
                <el-image fit="fill" style="width: 80px; height: 80px;" :src="scope.row.imgF" class="cursor"><template #error><div class="el-img-error">暂无图片</div></template></el-image>
              </el-space>
            </template>
          </el-table-column>
          <el-table-column label="实名信息" v-if="checkColList.indexOf('实名信息') > -1" min-width="160">
            <template #default="scope">
              <p v-if="scope.row.identityName">实名： {{ scope.row.identityName }}</p>
              <get-plain v-if="scope.row.identityCode && scope.row.identityCode !=0" title="身份证号：" :code="scope.row.identityCode" :uid="scope.row.uid" :type="10" :subType="1"/>
              <p style="color: red" v-if="isNonage">未成年</p>
            </template>
          </el-table-column>
          <el-table-column label="身份认证类型" v-if="checkColList.indexOf('身份认证类型') > -1" min-width="130">
            <template #default="scope">
              <p>{{scope.row.type == 1 ? "身份证" : scope.row.type == 2 ? "非身份证" : scope.row.type == 3 ? "其它" : ""}}</p>
            </template>
          </el-table-column>
          <el-table-column label="身份认证状态" v-if="checkColList.indexOf('身份认证状态') > -1" min-width="130">
            <template #default="scope">
              <p>{{scope.row.identityState == 0 ? "未提交" : scope.row.identityState == 1 ? "待审核" : scope.row.identityState == 2 ? "审核通过" : scope.row.identityState == 3 ? "审核不通过" : ""}}</p>
            </template>
          </el-table-column>
          <el-table-column label="芝麻/百度认证" v-if="checkColList.indexOf('芝麻/百度认证') > -1" min-width="160">
            <template #default="scope">
              <div v-if="scope.row.zhimaState != null" style="margin: 16px 0;">
                <p style="font-weight: bold;">芝麻认证</p>
                <p>时间：{{scope.row.zhimaUpdateTime}}</p>
                <p>实名：{{scope.row.zhimaCertName}}</p>
                <get-plain title="身份证号：" :code="scope.row.zhimaCertCode" :uid="scope.row.uid" :type="10" :subType="2"/>
                <p>状态：<span  :style="{color: scope.row.zhimaState == 1?'#409eff':'red'}">{{scope.row.zhimaState == 1?'认证成功':scope.row.zhimaState == 0?'认证失败':''}}</span></p>
                <el-button type="success" size="small" @click="updateIdenState(scope.$index, scope.row, 1, 1)" v-if="scope.row.zhimaState == 0" v-loading="scope.row['updateStateLoading']">通过</el-button>
                <el-button type="danger" size="small" @click="updateIdenState(scope.$index, scope.row, 1, 0)" v-if="scope.row.zhimaState == 1"  v-loading="scope.row['updateStateLoading']">不通过</el-button>
              </div>
              <div v-if="scope.row.baiduState != null" style="margin: 16px 0;">
                <p style="font-weight: bold;">百度认证</p>
                <p>时间：{{ scope.row.baiduUpdateTime }}</p>
                <p>实名：{{ scope.row.baiduCertName }}</p>
                <get-plain title="身份证号：" :code="scope.row.baiduCertCode" :uid="scope.row.uid" :type="10" :subType="3"/>
                <p>状态：<span  :style="{color: scope.row.baiduState == 1?'#409eff':'red'}">{{scope.row.baiduState == 1?'认证成功':scope.row.baiduState == 0?'认证失败':''}}</span></p>
                <el-button type="success" size="small" @click="updateIdenState(scope.$index, scope.row, 2, 1)" v-if="scope.row.baiduState == 0" v-loading="scope.row['updateStateLoading']">通过</el-button>
                <el-button type="danger" size="small" @click="updateIdenState(scope.$index, scope.row, 2, 0)" v-if="scope.row.baiduState == 1"  v-loading="scope.row['updateStateLoading']">不通过</el-button>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="总状态" v-if="checkColList.indexOf('总状态') > -1" width="120">
            <template #default="scope">
              <span>{{scope.row.overallAuthState==0?'未提交':scope.row.overallAuthState==1?'待审核':scope.row.overallAuthState==2?'审核通过':scope.row.overallAuthState==3?'审核不通过':''}}</span>
              <p :style="{color:scope.row.focusState > 3?'red':'#aaaaaa' }">{{
                  scope.row.focusState == 0?'未关注':
                  scope.row.focusState == 1?"已关注":
                  scope.row.focusState == 2?"自动取消关注":
                  scope.row.focusState == 3?"手动取消关注":
                  scope.row.focusState == 4?"已关注-封号":
                  scope.row.focusState == 5?"已关注-手动":
                  scope.row.focusState == 6?"已关注-设备异常":
                  scope.row.focusState == 7?"已关注-IP异常":
                  scope.row.focusState == 8?"已关注-订单异常":
                  scope.row.focusState == 9?"已关注-省份不一致":""
                }}</p>
            </template>
          </el-table-column>
          <el-table-column label="用户日志" v-if="checkColList.indexOf('用户日志') > -1" class-name="cursor" width="200">
            <template #default="scope">
              <UserLog :user-log-list="scope.row.userLogList" />
            </template>
          </el-table-column>
        </el-table>
        <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import DatePickerRange from '../../components/DatePickerRange'
import DatePickerRange30 from '../../components/DatePickerRange'
import SearchComponents from '../../components/SearchComponents'
import {
  getIdentityPageList, updateCertifyState, updateResumeFocusState
} from '../../api/url'
import { getFormData, postJson, postFormData } from '../../api/api'
import Dialog from '../../assets/js/dialog'
import SendSystemMessage from "@/components/SendSystemMessage";
import UserLogDialog from '../../components/UserLog/UserLogDialog'
import ImgViewer from '../../assets/js/imageViewer'
import {common, auth, identity} from "@/assets/shared/select-constant";
import UserLog from "@/components/UserLog/UserLog";
import GetPlain from "@/components/resume/GetPlain";
import IdentityRejectDialog from "./components/identity/IdentityRejectDialog";
import IdentityExamine from "./components/identity/IdentityExamine";
import RepeatDialog from "./components/identity/RepeatDialog";
import SearchUidOrPhone from '../../components/SearchUidOrPhone'
import VipUserSearchInfoDialog from "@/views/vip/components/VipUserSearchInfoDialog";


export default {
  name: "ReviewIdentity",
  components: { DatePickerRange, SearchComponents, UserLog, GetPlain, DatePickerRange30, SearchUidOrPhone },
  data() {
    return {
      sexArray: common.sexList,
      sex: common.sexList[2]['value'],

      overallAuthStateArray: auth.overallAuthStateList,
      overallAuthState: auth.overallAuthStateList[0]['value'],


      //公开
      openStateArray: [
        {label: '不限', value: -1},
        {label: '待补全信息', value: 0},
        {label: '待公开', value: 1},
        {label: '公开-手动', value: 2},
        {label: '不公开-手动', value: 3},
        {label: '公开-头像机审', value: 4},
        {label: '不公开-头像机审', value: 5},
      ],
      openState: -1,

      // 认证类型
      authTypeArray: [
        {label: '不限', value: -1},
        {label: '人工认证', value: 1},
        {label: '芝麻认证', value: 2},
        {label: '百度认证', value: 3},
      ],
      authType: 1,

      // 身份认证类型
      typeArray: [
        {label: '不限', value: -1},
        {label: '身份证', value: 1},
        {label: '非身份证', value: 2},
        {label: '其它', value: 3},
      ],
      type: -1,

      // 封号状态
      forbiddenStateArray: [
        {label: '不限', value: -1},
        {label: '未封号', value: 0},
        {label: '已封号', value: 1},
      ],
      forbiddenState: 0,

      // 注销状态
      resumeDelArray: [
        {label: '不限', value: -1},
        {label: '未注销', value: 0},
        {label: '已注销', value: 1},
      ],
      resumeDel: 0,

      //进入情况
      enterTypeArray: identity.enterTypeList,
      enterType: identity.enterTypeList[2]['value'],

      //身份认证状态
      idenStateArray: [],
      idenState: 1,

      //总状态
      stateArray: identity.stateList,
      state: identity.stateList[0]['value'],

      passLoading: false,


      //提交时间
      startTime: '',
      endTime: '',
      isChecked: true,

      //登陆时间
      startLoginTime: '',
      endLoginTime: '',
      isLoginChecked: false,

      //搜索
      searchTypeList: [
        {label : '手机号', value : 1},
        {label : '昵称', value : 2},
        {label : '用户ID', value : 3},
        {label : '用户日志', value : 4},
        {label : '身份证号', value : 5},
        {label : '身份证名', value : 6},
        {label : '邀请码', value : 7},
      ],
      searchType: 3,
      searchValue: '',

      //关注类型
      focusStateArray: [
        {label: '不限', value: -1},
        {label: '未关注', value: 0},
        {label: '已关注', value: 1},
        {label: '自动取消关注', value: 2},
        {label: '手动取消关注', value: 3},
        {label: '已关注-封号', value: 4},
        {label: '已关注-手动', value: 5},
        {label: '已关注-设备异常', value: 6},
        {label: '已关注-IP异常', value: 7},
        {label: '已关注-订单异常', value: 8},
        {label: '已关注-省份不一致', value: 9},
      ],
      focusState: -1,

      //刷新组
      colList: ['认证时间','提交时间', '头像', '用户信息', '进入情况', '期望结婚时间', '身份证照片', '实名信息','身份认证类型', '身份认证状态', '芝麻/百度认证', '总状态', '用户日志'],
      checkColList: [],

      pageDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,
      listLoading: false,
      searchLoading: false,
      updateLoading: false,
      focusLoading: false,

      //选中id
      idArray: [],
      userIdArray: [],
      //选中性别
      userSexArray: [],

      showSearch: false,
    }
  },
  methods: {

    idenStartChange() {
      if(this.authType == -1) {
        this.idenStateArray = [{label: '不限', value: -1}];
        this.idenState = -1;
      } else if(this.authType == 1) {
        this.idenStateArray = identity.stateList;
        this.idenState = 1;
      } else if(this.authType == 2 || this.authType == 3) {
        this.idenStateArray = [
          {label: '不限', value: -1},
          {label: '审核通过', value: 1},
          {label: '审核不通过', value: 0}
        ];
        this.idenState = -1;
      }
    },

    getTime(val) {
      this.startTime = val[0];
      this.endTime = val[1];
      // console.log(val)
    },
    getCheck(val) {
      this.isChecked = val
    },

    getLoginTime(val) {
      this.startLoginTime = val[0];
      this.endLoginTime = val[1];
      // console.log(val)
    },
    getLoginCheck(val) {
      this.isLoginChecked = val
    },

    getSearchType(e) {
      this.searchType = e;
      // console.log(e)
    },
    getSearchValue(e) {
      this.searchValue = e;
      // console.log(e)
    },
    // 展示表格的列
    colListChange(val) {
      this.checkColList = val;
    },
    // 重置参数
    refreshParam() {
      this.isChecked = true;
      this.isLoginChecked = true;
      this.sex = 2;
      this.openState = 0;
      this.authType = 1;
      this.enterType = 100;
      this.idenState = 1;
      this.overallAuthState = -1;
      this.type = -1;
      this.startTime = '';
      this.endTime = '';
      this.searchValue = '';
      this.focusState = -1;
      setTimeout(()=> {
        this.getPage(true);
      }, 500)
    },
    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },

    //获取选中id
    selsChange(sels) {
      this.idArray = sels.map(item => item.userId);
    },

    //全选
    selsAll(column, event) {
      if(column.type == 'selection') {
        let array = this.idArray;
        if(array.length == this.pageDataList.length) {
          array = [];
        }
        this.pageDataList.forEach(item => {
          if(array.indexOf(item.userId) === -1) {
            this.$refs.multipleTableRef.toggleRowSelection(item);
          }
        })
      }
    },

    getPage(reset) {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['sex'] = this.sex;
      param['overallAuthState'] = this.overallAuthState;
      param['authType'] = this.authType;
      param['enterType'] = this.enterType;
      param['openState'] = this.openState;
      param['type'] = this.type;
      param['state'] = this.idenState;
      param['startTime'] = this.startTime;
      param['endTime'] = this.endTime;
      param['loginStartTime'] = this.startLoginTime;
      param['loginEndTime'] = this.endLoginTime;
      param['searchType'] = this.searchType;
      param['searchValue'] = this.searchValue;
      param['resumeDel'] = this.resumeDel;
      param['forbiddenState'] = this.forbiddenState;
      param['focusState'] = this.focusState;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getIdentityPageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.totalRow = result['total'];
          this.pageSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch((response) => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },


    //图片预览

    showImg(img) {
      let imgList = []
      imgList.push(img)
      ImgViewer.open({
        imgList
      })
    },

    toggleSelection(row, column, cell, event) {

      if(column.type == 'selection') {
        this.$refs.multipleTableRef.toggleRowSelection(row)
      }

      //更新用户日志
      if(column.label == '用户日志') {
        Dialog.open({
          title: '用户日志',
          component: UserLogDialog,
          data: {
            id: row.userId
          },
          close: () => {
            row['userLogList'] = JSON.parse(sessionStorage.getItem('userLog'));
          }
        })
      }

      //身份审核
      if(column.label == '身份证照片') {
        if(row.imgZ == '' && row.imgF == ''){
          return;
        }
        let identityForm = Object.assign({}, row);
        Dialog.open({
          title: '身份证审核',
          component: IdentityExamine,
          data: {
            identityForm: identityForm,
            width: '1300px'
          },
          confirm: (result) => {
            for(let i = 0; i < this.pageDataList.length; i++) {
              if(row.userId == this.pageDataList[i].userId) {
                this.pageDataList.splice(i, 1);
              }
            }
          }
        })
      }


    },

    //搜索
    openDialog(e) {
      // console.log(e)
      let identityForm = e
      if(e.identityAuth) {
        identityForm.overallAuthState = e.identityAuth.overallAuthState
        identityForm.identityState = e.identityAuth.identityState
        identityForm.type = e.identityAuth.type
      }

      Dialog.open({
        title: '身份证审核',
        component: IdentityExamine,
        data: {
          identityForm: e,
          width: '1300px',
          isOperation: true, //是否实名操作
        },
        confirm: (result) => {

        }
      })
    },


    //发送系统消息
    sendSysMsg() {
      if(this.idArray.length == 0) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请至少选择一条记录进行操作',
          type: 'warning'
        })
        return false
      }
      Dialog.open({
        title: '发送小助手通知',
        component: SendSystemMessage,
        data: {
          userIdArray: this.idArray,
          width: '600px'
        },
        confirm: () => {

        }
      })
    },

    batchReject() {
      if(this.idArray.length > 0) {
        Dialog.open({
          title: '不通过原因',
          component: IdentityRejectDialog,
          data: {
            idArray: this.idArray,
            width: '500px'
          },
          confirm: () => {
            for(let j=0;j<this.idArray.length;j++) {
              for(let i=0;i<this.pageDataList.length;i++) {
                if(this.pageDataList[i]['userId'] == this.idArray[j]) {
                  this.pageDataList.splice(i,1);
                  i--;
                }
              }
            }
            if(this.pageDataList.length == 0) {
              this.getPage(false);
            }
          }
        })
      } else {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请至少选择一位用户进行专区操作',
          type: 'warning'
        })
      }
    },

    //身份证号码重复
    repeat(row) {
      let identityForm = Object.assign({}, row);
      Dialog.open({
        title: '新认证用户的身份证号码已存在',
        component: RepeatDialog,
        data: {
          identityForm: identityForm,
          width: '800px'
        },
        confirm: (result) => {

        }
      })
    },

    // 更改芝麻/百度认证状态
    updateIdenState(idx, row, type ,state) {
      this.$confirm("你确定要" + (state == 1?'通过':'不通过') + "用户【" + row['nickName'] + '】的' + (type == 1?'芝麻':'百度') + '认证？').then(() => {
        row['updateStateLoading'] = true;
        let _this = this;
        let param = {};
        param['id'] = row.userId
        param['state'] = state;
        param['type'] = type;
        postFormData(updateCertifyState, param).then(function(data){
          let {code, msg} = data;
          if(code == 200){
            _this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'success'
            });
            _this.pageDataList.splice(idx,1)
          } else {
            _this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'warning'
            });
          }
          row['updateStateLoading'] = false;
        })
            .catch(function(response){
              row['updateStateLoading'] = false;
            })
      })
          .catch(() => {})
    },

    //设为关注
    updateFocusState(state) {
      if(this.idArray.length == 0) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请至少选择一位用户进行专区操作',
          type: 'warning'
        })
        return false
      }
      this.$confirm('确定批量设置为' + (state==5?'【关注用户】':'【不关注用户】') + '?').then(()=>{
        this.focusLoading = true
        let param = {}
        param['idArr'] = this.idArray
        param['focusState'] = state
        postFormData(updateResumeFocusState, param).then((data)=>{
          let {code, msg} = data
          if(code == 200) {
            this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'success'
            })
            this.getPage()
          }else {
            this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'warning'
            })
          }
          this.focusLoading = false
        }).catch(()=>{
          this.focusLoading = false
        })
      })
    },



  },
  mounted() {
    this.$nextTick(function() {
      this.checkColList = this.colList;
    })
    this.getPage();
    this.idenStartChange();
  }
}
</script>

<style scoped>
.playBtn {
  font-size: 5em;
  color: #c0c4cc;
  cursor: pointer;
}
.playBtn:hover {
  font-size: 5em;
  color: #3a8ee6;
}
</style>
